/* global axios */

class PipelineMembersAPI {
  get(accountId, pipelineId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/pipelines/${pipelineId}/members`
    );
  }

  update(accountId, pipelineId, userIds) {
    return axios.put(
      `/api/v1/accounts/${accountId}/pipelines/${pipelineId}/members`,
      { user_ids: userIds }
    );
  }
}

export default new PipelineMembersAPI();
